import {
  RESET_COMPANY,
  API_ERROR,
  GET_COMPANY,
  SET_COMPANY,
  EDIT_COMPANY,
  EDIT_COMPANY_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorCompany: false,
  loadingCompany: false,
  dataCompany: null,
};

const company = (state = initialState, action) => {
  switch (action.type) {
    case RESET_COMPANY:
      state = initialState;
      break;
    case GET_COMPANY:
      state = {
        errorCompany: false,
        loadingCompany: true,
      };
      break;
    case SET_COMPANY:
      state = {
        errorCompany: false,
        loadingCompany: false,
        dataCompany: action.payload,
      };
      break;
    case EDIT_COMPANY:
      state = {
        errorCompany: false,
        loadingCompany: true,
        dataCompany: action.payload,
      };
      break;
    case EDIT_COMPANY_SUCCESS:
      state = {
        errorCompany: false,
        loadingCompany: false,
        dataCompany: action.payload,
        successCompany: true,
      };
      break;    
    case API_ERROR:
      state = {
        ...state,
        errorCompany: action.payload,
        loadingCompany: false,
        dataCompany: null,
        successCompany: false,
      };
      break;
    default:
      // state = { ...state, errorCompany: false, loadingCompany: false };
      break;
  }
  return state;
};

export default company;
